import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import I18n from 'i18n-react';
import './OverviewPriceSummary.css';
import FormatValue from '../../../utils/FormatValue';

const propTypes = {
  id: PropTypes.string.isRequired,
  totalAdult: PropTypes.string.isRequired,
  totalChildren: PropTypes.string,
  totalInfant: PropTypes.string,
  totalTaxes: PropTypes.string,
  totalTaxesAndMoney: PropTypes.number,
  adultNumber: PropTypes.number,
  childNumber: PropTypes.number,
  infantNumber: PropTypes.number,
  totalMoneyAdult: PropTypes.number,
  totalMoneyChild: PropTypes.number,
  totalMoneyInfant: PropTypes.number
};

const defaultProps = {
  totalChildren: null,
  totalInfant: null,
  totalTaxes: null
};

class OverviewPriceSummary extends React.Component {
  renderSummaryWithIcon(id, typeName, value) {
    return (
      <Row className="OverviewPriceSummary__PriceContainer">
        <Col xs={6} className="OverviewPriceSummary__PriceDescripion">
          <label className="OverviewPriceSummary__PriceType">{typeName}</label>
          <i className="OverviewPriceSummary__InfoIcon" />
        </Col>
        {this.renderPriceValueDescription(id, value, false)}
      </Row>
    );
  }

  renderSummaryForType(id, typeName, value, isPoint = true, moneyOfPointsPlusMoney) {
    if (value == null) {
      return null;
    }
    return (
      <Row className="OverviewPriceSummary__PriceContainer">
        <Col xs={6} className="OverviewPriceSummary__PriceDescripion">
          <label>{typeName}</label>
        </Col>
        {this.renderPriceValueDescription(id, value, isPoint, moneyOfPointsPlusMoney)}
      </Row>
    );
  }

  renderPriceValueDescription(id, value, isPoint, moneyOfPointsPlusMoney) {
    const isPointsPlusMoney = moneyOfPointsPlusMoney > 0;
    return (
      <Col xs={6} className={!isPointsPlusMoney ? "OverviewPriceSummary__PriceValue" : "OverviewPriceSummary__PriceValue OverviewPriceSummary__marginPointsPlusMoney"}>
        <label id={id}>{isPointsPlusMoney ? this.renderPointsPlusMoney(value, moneyOfPointsPlusMoney) : this.renderPriceValue(value, isPoint)}</label>
      </Col>
    );
  }

  renderPriceValue(value, isPoints) {
    return `${!isPoints ? I18n.translate('components.OverviewPriceSummary.rs') + ' ' : ''}${value ? value : '-'
      }${isPoints ? ' ' + I18n.translate('components.OverviewPriceSummary.pts') : ''}`;
  }

  renderPointsPlusMoney(value, moneyOfPointsPlusMoney) {
    return (
      <div>
        {I18n.translate('pointsPlusMoney.priceSummary.points', {
          points: value
        })} <br></br>
        {I18n.translate('pointsPlusMoney.priceSummary.money', {
          money: FormatValue.formatAmount(moneyOfPointsPlusMoney)
        })}
      </div>
    );
  }

  render() {
    return (
      <div id={`componentOverviewPriceSummary-${this.props.id}`} className="OverviewPriceSummary">
        {this.renderSummaryForType(
          'lblTotalAdultValue',
          I18n.translate('components.OverviewPriceSummary.totalAdult', {total : this.props.adultNumber}),
          this.props.totalAdult,
          true,
          this.props.totalMoneyAdult
        )}
        {this.renderSummaryForType(
          'lblTotalChildrenValue',
          I18n.translate('components.OverviewPriceSummary.totalChildren', {total : this.props.childNumber }),
          this.props.totalChildren,
          true,
          this.props.totalMoneyChild
        )}
        {this.renderSummaryForType(
          'lblTotalInfantValue',
          I18n.translate('components.OverviewPriceSummary.totalInfant', {total : this.props.infantNumber}),
          this.props.totalInfant,
          true,
          this.props.totalMoneyInfant
        )}
        {this.props.totalMoneyAdult === 0 ? this.renderSummaryWithIcon(
          'lblTotalTaxesValue',
          I18n.translate('components.OverviewPriceSummary.totalTaxes'),
          this.props.totalTaxes
        ) : null}
      </div>
    );
  }
}

OverviewPriceSummary.propTypes = propTypes;
OverviewPriceSummary.defaultProps = defaultProps;

export default OverviewPriceSummary;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/overviewPriceSummary/OverviewPriceSummary.jsx